/* eslint-disable no-shadow,no-param-reassign */
const initialState = {
  isAuth: false,

  user: {
    id: null,
    firstName: null,
    lastName: null,
    roleId: null
  },

  navToggle: false,
  printing: false
};

export const state = initialState;

export const getters = {
  isAdmin: state => state.user.roleId === "Admin",
  navToggle: state => state.navToggle,
  printing: state => state.printing,
  isUser: state => state.user.roleId === "User",
  currentUser: state => state.user
};

export const actions = {
  loggedIn({ commit }) {
    commit("auth", true);
  },

  loggedOut({ commit }) {
    commit("auth", false);
  },

  setUser({ commit }, payload) {
    commit(
      "setUser",
      Object.assign({}, payload.attributes, { id: payload.id })
    );
  },

  reset({ commit }) {
    commit("reset");
  },

  navToggle({ commit }) {
    commit("navToggle");
  },
  isPrinting({ commit }) {
    commit("printing", true);
  },
  notPrinting({ commit }) {
    commit("printing", false);
  }
};

export const mutations = {
  auth(state, x) {
    state.isAuth = x;
  },

  setUser(state, user) {
    state.user = user;
  },

  reset(state) {
    state.user = {};
  },

  navToggle(state) {
    state.navToggle = !state.navToggle;
  },

  printing(state, flag) {
    state.printing = flag;
  }
};
